import { EncryptionService } from "@marketplace/shared/services";
import { captureException } from "@marketplace/shared/utils";

const GUEST_LOGIN_SECRET_KEY = import.meta.env.VITE_GUEST_LOGIN_KEY;

interface GuestLoginData {
  password: string;
}

export class GuestLoginEncryptionService {
  private static instance: GuestLoginEncryptionService;
  private readonly encryptionService: EncryptionService;

  private constructor() {
    this.encryptionService = new EncryptionService({
      secretKey: GUEST_LOGIN_SECRET_KEY,
      onError: captureException
    });
  }

  public static getInstance(): GuestLoginEncryptionService {
    if (!GuestLoginEncryptionService.instance) {
      GuestLoginEncryptionService.instance = new GuestLoginEncryptionService();
    }
    return GuestLoginEncryptionService.instance;
  }

  public async encrypt(data: GuestLoginData): Promise<string> {
    try {
      return await this.encryptionService.encrypt(
        `${data.password}|${Math.round(Date.now() / 1000)}`
      );
    } catch (error) {
      console.error(error);
      captureException(
        new Error(`Failed to encrypt guest login data: ${error}`)
      );
      throw new Error("Failed to encrypt guest login data", { cause: error });
    }
  }

  public async decrypt(data: string): Promise<GuestLoginData> {
    try {
      const decryptedData = await this.encryptionService.decrypt<string>(data);
      const decryptedPayload = decryptedData.split("|");

      // Validate decrypted data
      if (!decryptedPayload[0]) {
        throw new Error("Invalid guest login data");
      }

      return {
        password: decryptedPayload[0]
      };
    } catch (error) {
      console.error(error);
      captureException(
        new Error(`Failed to decrypt guest login data: ${error}`)
      );
      throw new Error("Failed to decrypt guest login data", { cause: error });
    }
  }
}
